import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=46dc05e5&"
import script from "./Loading.ts?vue&type=script&lang=ts&"
export * from "./Loading.ts?vue&type=script&lang=ts&"
import style0 from "./Loading.vue?vue&type=style&index=0&id=46dc05e5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports